var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkAddGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2vvynrzc6a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 6.836a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333zm-4 2.667c.16 0 .31-.038.444-.104a3.668 3.668 0 0 0 7.223-.896 3.667 3.667 0 0 0-7.223-.897.996.996 0 0 0-.444-.103h-8a1 1 0 0 0-1 1v3.333a1 1 0 1 0 2 0V9.503h7zm-8 18.666a1 1 0 0 1 1 1v2.334h7c.16 0 .31.037.444.103a3.668 3.668 0 0 1 7.223.897 3.667 3.667 0 0 1-7.223.896.996.996 0 0 1-.444.104h-8a1 1 0 0 1-1-1v-3.334a1 1 0 0 1 1-1zm3.667-7.666a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0zm1.666-3.667a3.667 3.667 0 1 0 0 7.333 3.667 3.667 0 0 0 0-7.333zm6.667 14a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333zM13 14.503a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5a1 1 0 0 0 2 0v-5h5a1 1 0 0 0 0-2h-5v-5z",
    fill: "#500D76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2vvynrzc6a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 4.5)",
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkAddGroups);
export default __webpack_public_path__ + "static/media/bulkAddGroups.3d4320f2828106939ebbc18724f72b73.svg";
export { ForwardRef as ReactComponent };